<div class="meter-selection">
  <mat-radio-group class="radio-group" aria-labelledby="radio-group-label" [(ngModel)]="filter.meterSelection">
    <mat-radio-button *ngFor="let option of options" [value]="option.type" (change)="onSelectionChange(option.type)">
      {{ option.name }}
    </mat-radio-button>
  </mat-radio-group>

  <label>{{ 'module.shared.excelDownloadWizard.meterSelectionLabelText' | translate }}</label>
</div>
